
export const TMDB_API_KEY = '807e85168ae455c6cc5f564d5cbd9b6c';
export const AWS_ACCESS_KEY = 'us-east-2_hdmzoW9gP';
export const AWS_SECRET_KEY = 'us-east-2:1ecf168c-c805-4dc2-b590-95716f430373';
export const IDENTITY_POOL_ID = 'us-east-2:32013d8b-eb95-47f6-bd53-39817c0318d3';
export const REGION = 'us-east-2';